export default {
  "Junior": 1,
  "Medior 1": 2,
  "Medior 2": 3,
  "Senior 1": 4,
  "Senior 2": 5,
  "Principal 1": 6,
  "Principal 2": 7,
}